// import * as Routes from '../constants/routes';
// import { trackingEvent } from '../helpers/tracking';

// import Intro from '../calculators/pay-yourself-first/containers/intro';
import RetirementCalculator from "../calculators/retirement-planning/containers/retirement-calculator";
import InflationIncome from '../calculators/retirement-planning/containers/inflation-income';
import MoneyLast from '../calculators/retirement-planning/containers/money-last';
import RRIFPayment from '../calculators/retirement-planning/containers/rrif-payment';
import TFSARRSP from '../calculators/retirement-planning/containers/tfsa-rrsp';
import CPPTakeEarly from '../calculators/retirement-planning/containers/cpp-take-early';
import LifPayment from '../calculators/retirement-planning/containers/lif-payment';

export const name = 'Retirement Planning';

export const inSecondaryMenu = true;

export const routes = [
    // {
    //     path: Routes.HOME,
    //     component: Intro,
    //     pagination: false,
    //     progressBar: false
    // },
    {
        path: '/retirement-calculator',
        name: 'Retirement Calculator',
        component: RetirementCalculator,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/inflation-income',
        name: 'Inflation and your Retirement Income',
        component: InflationIncome,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/money-last',
        name: 'Will the Money Last?',
        component: MoneyLast,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/rrif-payment',
        name: 'RRIF Payment',
        component: RRIFPayment,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/tfsa-rrsp',
        name: 'TFSA vs. RRSP',
        component: TFSARRSP,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/cpp-take-early',
        name: 'CPP Early or Later',
        component: CPPTakeEarly,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/lif-payment',
        name: 'LIF Calculator',
        component: LifPayment,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    }
];
